export default "__VITE_ASSET__64308984__"